import { render, staticRenderFns } from "./ComposedPackSection.vue?vue&type=template&id=12279a7d&"
import script from "./ComposedPackSection.vue?vue&type=script&lang=js&"
export * from "./ComposedPackSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports